import { Button, Col, Modal, Row, Typography } from 'antd';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface PrimeContractCreateSelectModalProps {
  visible: boolean;
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function PrimeContractCreateSelectModal({
  visible,
  onCreate,
  onCancel,
}: PrimeContractCreateSelectModalProps) {
  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="도급계약 추가"
        onCancel={onCancel}
        footer={null}
      >
        <>
          <Row justify="center">
            <Col>
              <Typography.Text>
                기존 도급계약에서 집계내역을 불러오시겠습니까? (불러온
                집계내역은 수정 가능)
              </Typography.Text>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: '40px' }}>
            <Col style={{ marginRight: '20px' }}>
              <Button onClick={() => onCreate('0')} style={{ width: '100px' }}>
                예
              </Button>
            </Col>
            <Col>
              <Button onClick={() => onCreate('1')} style={{ width: '100px' }}>
                아니오
              </Button>
            </Col>
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default PrimeContractCreateSelectModal;
